import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Icon from '../Icon';
import { getTranslation } from '../../providers/TranslationProvider';
import CalendarIcon from '../../svg/icons/ic_calendar-solid_20x20.svg';
import PeopleIcon from '../../svg/icons/ic_guests_20x20.svg';

const NotifyPostStateSummary = (props) => {
  const {
    children,
    notifyStart,
    notifyEnd,
    selectedDate,
    selectedQuantity,
    venueName,
    eventName,
  } = props;

  const isEvent = !!eventName;
  const summaryLabel = isEvent ? venueName : '';
  const summaryName = isEvent ? eventName : venueName;
  const formattedForReservationSummary = moment(selectedDate).format('YYYY-MM-DD');
  const summaryQuantity = getTranslation({
    translationKey: 'number_guests',
    translationValues: { number: `${selectedQuantity}` },
    fallback: `${selectedQuantity} Guests`,
  });
  return (
    <div className="Notify__body Notify__body--available">
      {isEvent && <div className="Notify__event-label">{summaryLabel}</div>}
      <h3>{summaryName}</h3>
      <div className="Notify__body__row">
        <Icon component={CalendarIcon} name="calendar" />
        {`${moment(`${formattedForReservationSummary} ${notifyStart}`).format('llll')} - ${moment(notifyEnd, 'HH:mm').format('LT')}`}
      </div>
      <div className="Notify__body__row">
        <Icon component={PeopleIcon} name="people" />
        <span>{summaryQuantity}</span>
      </div>
      {children}
    </div>
  );
};

NotifyPostStateSummary.propTypes = {
  children: PropTypes.node,
  notifyStart: PropTypes.string,
  notifyEnd: PropTypes.string,
  selectedDate: PropTypes.instanceOf(Date),
  selectedQuantity: PropTypes.number,
  venueName: PropTypes.string,
  eventName: PropTypes.string,
};

NotifyPostStateSummary.defaultProps = {
  children: undefined,
  notifyStart: undefined,
  notifyEnd: undefined,
  selectedDate: undefined,
  selectedQuantity: undefined,
  venueName: undefined,
  eventName: undefined,
};

export default NotifyPostStateSummary;
